import { Card, CardActionArea, CardContent, CardMedia, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const CreateFromScratchCard: FC = () => {
  const { t } = useTranslation();
  return (
    <Card raised>
      <CardActionArea href="/moments" sx={{ height: "100%" }} draggable={false}>
        <CardMedia
          image="https://images.changeengine.com/ce-cards/create-from-scratch.png"
          alt="Blank Canvas"
          component="img"
          height="150px"
          draggable={false}
        />

        <CardContent>
          <Typography variant="h6">{t("Communication from Scratch")}</Typography>
          <Typography variant="body1" mt={2}>
            {t(
              "Create a highly customized Communication using the power of our AI and Image Designer tools",
            )}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
